/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Light response for TiersPayant
 * @export
 * @interface TiersPayantLightResponse
 */
export interface TiersPayantLightResponse {
    /**
     * UUID of the TiersPayant
     * @type {string}
     * @memberof TiersPayantLightResponse
     */
    uuid?: string;
    /**
     * Creation timestamp of the TiersPayant sheet
     * @type {string}
     * @memberof TiersPayantLightResponse
     */
    tpCreationTimestamp?: string;
}

/**
 * Check if a given object implements the TiersPayantLightResponse interface.
 */
export function instanceOfTiersPayantLightResponse(value: object): value is TiersPayantLightResponse {
    return true;
}

export function TiersPayantLightResponseFromJSON(json: any): TiersPayantLightResponse {
    return TiersPayantLightResponseFromJSONTyped(json, false);
}

export function TiersPayantLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TiersPayantLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'tpCreationTimestamp': json['tpCreationTimestamp'] == null ? undefined : json['tpCreationTimestamp'],
    };
}

export function TiersPayantLightResponseToJSON(json: any): TiersPayantLightResponse {
    return TiersPayantLightResponseToJSONTyped(json, false);
}

export function TiersPayantLightResponseToJSONTyped(value?: TiersPayantLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'tpCreationTimestamp': value['tpCreationTimestamp'],
    };
}

